module.exports = __webpack_public_path__ + "img/20231010144624592fd2.2f0e0c0f.jpg";